<template>
    <div class="componentsCtn_1">
        <div class="top">
            我的消息（{{unreadCount}}未读）
<!--            <span @click="markAsRead()" style="float:right;font-size: 16px;color: #1E81EB;font-weight: 300;margin-right: 57px;cursor:pointer;">全部标记为已读</span>-->
        </div>
        <div class="signUp_content">
            <div v-for="item in dataList" :key="item.id" :class="item.status=='0' ? 'signUp_item_banner2':'signUp_item_banner'">
                <div v-if="item.status=='0'" class="messageTip" style="top:70px;left:20px;">

                </div>
                <table>
                    <tr style="font-size: 14px;color: #979797;font-weight: 400;height: 28px;">
                        <td width="580px" style="vertical-align: text-top">消息内容</td>
                        <td width="240px" style="vertical-align: text-top">发送时间</td>
                        <td width="150px" style="vertical-align: text-top">操作</td>
                    </tr>
                    <tr style="height: 50px;font-size: 16px;" >
                        <td  style="vertical-align: text-top;width:425px;word-break: break-all;word-wrap:break-word;color: #3A3A3A;font-size: 16px;padding-right: 15px;">
                            {{item.content}}
                        </td>
                        <td style="vertical-align: text-top">
                            {{item.createTime}}
                        </td>
                        <td style="vertical-align: text-top;color: #1E81EB;cursor:pointer">
                            <span v-if="item.status=='0'">
                                <span v-if="item.type=='0'">
                                  <span @click="markAsRead_id(item.id,0,1,item.groupId)">接受邀请</span>&nbsp;&nbsp;
                                  <span @click="markAsRead_id(item.id,0,2,item.groupId)" style="color: #E02020">拒绝</span>
                                </span>
                                <span @click="markAsRead_id(item.id,1)" v-else-if="item.type=='1'">
                                    标记为已读
                                </span>
                              <span @click="markAsRead_id(item.id,2)" v-else-if="item.type=='2'">
                                    进入项目
                              </span>
                              <span @click="markAsRead_id(item.id,3)" v-else-if="item.type=='3'">
                                    查看任务
                              </span>
                              <span @click="markAsRead_id(item.id)" v-else>
                                    标记为已读
                              </span>
                            </span>
                            <span v-if="item.status=='1'" style="color: #979797">
                              <span v-if="item.type=='0'">
                                已处理
                              </span>
                              <span  v-else-if="item.type=='1'">
                                  已读
                              </span>
                              <span  v-else-if="item.type=='2'">
                                    已处理
                              </span>
                              <span  v-else-if="item.type=='3'">
                                    已处理
                              </span>
                              <span  v-else>
                                    已读
                              </span>
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    
</template>

<script>
    export default {
        name: "message",
        data(){
            return{
                dataList:[],
                unreadCount:0,

            }
        },
        methods:{
            getKey() {
                return localStorage.getItem("token");
            },
          //获取消息列表
            getSignUpData:function () {
                let that=this
                let pageData=new FormData();
                pageData.append("pageNo",1)
                pageData.append("pageSize",1000)
                this.axios.post("/tilesapi/tiles/message/list",pageData, {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((response) => {
                    console.log('我的消息')
                    console.log(response)
                    if(response.status==200){
                        that.dataList=response.data.data.records;
                        // that.unreadCount=response.data.data.messageUnreadCount;
                    }
                })
            },
          getUnreadCount:function () {
            this.axios.post("/tilesapi/tiles/message/queryMessageCount","", {
              headers: {
                Authorization: "Bearer " + this.getKey(),
              },
            }).then((response) => {
              console.log('我的消息未读数量')
              console.log(response)
              if(response.status==200){
                this.unreadCount=response.data.data;
              }
            })
          },
            markAsRead:function () {
                let that=this
                this.axios.post("/tilesapi/tiles/message/editAllStatus", {
                        headers: {
                            Authorization: "Bearer " + this.getKey(),
                        },
                    }).then((response) => {
                    console.log('标记为已读')
                    console.log(response)
                    that.getSignUpData();
                    location.reload();
                })
            },
          markAsRead_id: function (data, type, select, otherId) {
            //data是id，type消息类型，select同意拒绝
            console.log(data)
            let that = this
            //邀请加入团队，同意或拒绝
            if(type==0&&select){
              let param2 = new FormData();
              param2.append("groupId", otherId);
              param2.append("status", select);
              this.axios.post("/tilesapi/tiles/member/editInviteGroupStatus", param2, {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }).then((response) => {
                console.log('同意或拒绝加入团队')
                console.log(response)
                let param = new FormData();
                param.append("id", data);
                this.axios.post("/tilesapi/tiles/message/editAllStatus", param, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                  console.log('标记为已读')
                  console.log(response)
                  that.getSignUpData();
                  //跳转到团队
                  if(select==1){
                    that.$router.push({path: "/userCenter",query: {'type':3}});
                  }
                  this.getUnreadCount();
                  location.reload();
                })
              })
            }
            //查看任务
            else if(type==3){
              let param = new FormData();
              param.append("id", data);
              this.axios.post("/tilesapi/tiles/message/editAllStatus", param, {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }).then((response) => {
                console.log('标记为已读')
                console.log(response)
                that.getSignUpData();
                //跳转到任务
                this.$router.push({path: "/userCenter",query: {'type':2}});
                // location.reload();
                this.getUnreadCount();

              })
            }
            //直接标记为已读
            else {
              let param = new FormData();
              param.append("id", data);
              this.axios.post("/tilesapi/tiles/message/editAllStatus", param, {
                headers: {
                  Authorization: "Bearer " + this.getKey(),
                },
              }).then((response) => {
                console.log('标记为已读')
                console.log(response)
                that.getSignUpData();
                this.getUnreadCount();
                location.reload();
              })
            }
            this.getUnreadCount();

          },


        },
        mounted(){
            this.getSignUpData();
            this.getUnreadCount();

        }
    }
</script>

<style scoped>
    .messageTip{
        position:absolute;
        width: 6px;
        height: 6px;
        background: #FF4040;
        border-radius: 3px;
    }
    .signUp_item_banner{
        position:relative;
        width: 1032px;
        height: 122px;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_item_banner2{
        position:relative;
        width: 1032px;
        height: 122px;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-top:31px;
        padding-left:39px;
    }
    .signUp_content{
        width: 100%;
        height: 576px;
        padding-left: 35px;
        overflow-y: auto;
    }
    /*滚动条样式*/
    .signUp_content::-webkit-scrollbar {
        width: 4px;
    }
    .signUp_content::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .signUp_content::-webkit-scrollbar-track {
    }
    .top{
        height: 84px;
        line-height: 84px;
        padding-left: 35px;
        padding-right:37px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
    }
    .componentsCtn_1{
      width: 100%;
      min-height: 660px;
      height: auto;
      background: #F5F5F6;
      border-radius: 16px;
    }

</style>